import { faEnvelope, faExternalLinkAlt, faGlobeEurope, faMapMarker, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isDevelopment } from "consumerhouse-shared";
import React, { useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import AuthContext from "../AuthContext";
import { LanguageContext } from "../LanguageContext";
import { useLanguage } from "../useLanguage";
import { LinkButton } from "./LinkButton";

const OuterContainer = styled.footer`
    margin: 10em 0 0 0;
    padding: 0.5em 0;
    color: black;
    background: #333;
    font-size: 0.88em;
    color: white;

    @media only screen and (max-width: 600px) {
        font-size: 1.1em;
    }
`;

const InnerContainer = styled.div`
    margin: 1.5em 1em;
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: center;
    align-items: stretch;
`;

const Item = styled.div`
    padding: 0em 6em 1em 2em;
    min-width: 200px;

    @media only screen and (min-width: 600px) {
        &:not(:last-child) {
            border-right: 1px solid #666;
        }
    }

    @media only screen and (max-width: 600px) {
        width: 100%;
        border-top: 1px solid #666;
        padding: 2em 2em;
    }
`;

const Language = styled.a`
    cursor: pointer;
    padding: 0.1em 0.5em;
    font-weight: bold;
    text-decoration: none;
    color: #aabbfd;
`;

const Name = styled.span`
    /* color: #e7787f; */
    font-weight: bold;
`;

const Version = styled.span`
    opacity: 0.5;
    font-size: 0.8em;
`;

const FooterLink = styled.a`
    text-decoration: none;
    color: #ddd !important;
    &:hover {
        color: #aabbfd !important;
        text-decoration: underline;
    }
`;

const Line = styled.p`
    margin: 0.6em 0;
`;

const Region = styled.span`
    font-weight: bold;
    text-transform: capitalize;
    padding: 0em 0.5em;
    font-size: 0.9em;
`;

const RegionChange = styled.span`
    cursor: pointer;
    font-weight: bold;
    color: #aabbfd;
    font-size: 0.8em;
    padding: 0em 0.5em;
`;

const Weboot = styled.a`
    margin: 1.5em 0 0 0;
    font-weight: bold;
    align-self: flex-start;
    display: block;
    text-decoration: none;
    color: white;
`;

export default function Footer() {
    const { language: languageName, setLanguage } = useContext(LanguageContext);
    const { auth } = useContext(AuthContext);
    const history = useHistory();
    const language = useLanguage();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [languageName]);

    return (
        <>
            <OuterContainer>
                {languageName !== "nl_nl" && (
                    <InnerContainer>
                        <FontAwesomeIcon style={{ alignSelf: "center" }} icon={faGlobeEurope} />
                        {isDevelopment ? (
                            <>
                                <Language onClick={() => setLanguage("nl")}>Nederlands</Language>
                                <Language onClick={() => setLanguage("fr")}>Français</Language>
                            </>
                        ) : (
                            <>
                                <Language href="https://onderzoeken-consumerhouse.be">Nederlands</Language>
                                <Language href="https://etudes-consumerhouse.be">Français</Language>
                            </>
                        )}
                    </InnerContainer>
                )}

                {auth && (
                    <InnerContainer>
                        <Region>
                            <FontAwesomeIcon icon={faMapMarkerAlt} /> Regio {auth.user.activeRegionName}
                        </Region>
                        <RegionChange
                            onClick={() => {
                                history.push("/select-region");
                            }}>
                            {language("footer-select-region")}
                        </RegionChange>
                    </InnerContainer>
                )}
                {/* <InnerContainer>
                    {languageName === "nl_nl" ? (
                        <Language href="https://onderzoeken-consumerhouse.be">Naar Belgische website</Language>
                    ) : (
                        <Language href="https://onderzoeken-consumerhouse.nl">{language("footer-go-dutch")}</Language>
                    )}
                </InnerContainer> */}
                <InnerContainer style={{ margin: "2.5em 0 1em 0" }}>
                    <Item>
                        {/* <Name>
                            {language("footer-contact")} <Version>{version}</Version>
                        </Name> */}
                        <Line>
                            <FooterLink href="http://consumerhouse.be/">
                                <FontAwesomeIcon icon={faExternalLinkAlt} /> www.consumerhouse.be
                            </FooterLink>
                        </Line>
                        <Line>
                            <FooterLink href="https://www.google.com/maps/place/Ternesselei+324%2F1,+2160+Wommelgem,+Belgi%C3%AB/@51.2130198,4.4927466,17z/">
                                <FontAwesomeIcon icon={faMapMarker} /> Ternesselei 324/1
                                <br />
                                2160 Wommelgem
                            </FooterLink>
                        </Line>

                        <Line>
                            <h4>{language("email-support")}</h4>
                            <FooterLink href="mailto:support@consumerhouse.be">
                                <FontAwesomeIcon icon={faEnvelope} /> support@consumerhouse.be
                            </FooterLink>
                        </Line>
                        <Line>
                            <h4>{language("email-reward")}</h4>
                            <FooterLink href="mailto:incentives@consumerhouse.be">
                                <FontAwesomeIcon icon={faEnvelope} /> incentives@consumerhouse.be
                            </FooterLink>
                        </Line>
                        <Line>
                            <h4>{language("email-other")}</h4>
                            <FooterLink href="mailto:contact@consumerhouse.be">
                                <FontAwesomeIcon icon={faEnvelope} /> contact@consumerhouse.be
                            </FooterLink>
                        </Line>
                    </Item>
                    <Item>
                        <Name> {language("footer-account")} </Name>

                        <Link to="/account">
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("footer-account-my-tests")} </LinkButton>
                            </Line>
                        </Link>
                        <Link to={auth ? "/change-password" : "/reset-password"}>
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("footer-account-change-password")} </LinkButton>
                            </Line>
                        </Link>
                        <Link to="/account">
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("footer-account-logout")} </LinkButton>
                            </Line>
                        </Link>
                        <Link to="/account/delete">
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("footer-account-delete")} </LinkButton>
                            </Line>
                        </Link>
                    </Item>
                    <Item>
                        <Name> {language("footer-info")} </Name>
                        {/* <Link to="/faq">
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("faq")} </LinkButton>
                            </Line>
                        </Link> */}
                        <Link to="/terms-and-conditions">
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("footer-info-terms")} </LinkButton>
                            </Line>
                        </Link>
                        <Link to="/gdpr">
                            <Line>
                                <LinkButton style={{ color: "#aabbfd" }}> {language("footer-gdpr")} </LinkButton>
                            </Line>
                        </Link>
                        {/* <Weboot href="https://weboot.nl">
                            {language("footer-info-by")} <img alt="weboot" src="/weboot.png" />
                        </Weboot> */}
                    </Item>
                </InnerContainer>
            </OuterContainer>
        </>
    );
}
